import styled from 'styled-components'
const Wrapper = styled.div`
padding:0;
.login-form-heading{
    display: flex;
    align-items: center;
    gap: 0.3rem;
    justify-content: center;
     margin-top: 1.5rem;
         flex-direction: column;
}
.login-form-heading i{
    font-size: 2rem;
    color: rgb(52 52 52);
}
.login-form-heading h3{
    color: #374151;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
       margin-bottom: 0;
}

.input-group-text{
    background-color: #ffffff;
}



#captchaBox{
    user-select: none;
    filter: blur(0.6px);
    letter-spacing: 1rem;
}

.cus-login-btn{
    width: -webkit-fill-available;
    border: none;
    border-radius: 12px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), #3560CA;
    color: #ffffff;
    display: flex;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
}
.cus-reset-btn{
    width: -webkit-fill-available;
    border: none;
    border-radius: 12px;
    opacity: 0.8;
    background: #D3D3D3;
    display: flex;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
}
    .lock-icon{
            font-size: 1.2rem;
    color: #4546f7;
    }
    .login-text{
    display :flex;
    gap : 0.5rem;
        align-items: center;
    }
 `
  export default Wrapper